export const log = (message, ...params) => console.log(message, ...params); // eslint-disable-line no-console
export const warn = (message, ...params) => console.warn(message, ...params); // eslint-disable-line no-console
